// The bubble bleeds 8px past the text column, so any container holding messages needs this gutter to keep the rounded edges inside its clip box.
export const MESSAGE_SURFACE_GUTTER_CLASS = "px-2"

// Avatar size "s" and the system-event rail column, in Tailwind units.
export const MESSAGE_AVATAR_UNIT = 6
export const SYSTEM_EVENT_RAIL_UNIT = 8

// Nudges the rail onto the column the bubble's avatar sits in, so the line runs through every avatar above and below it.
export const SYSTEM_EVENT_RAIL_CLASS = "pl-0.5"

// The gray bubble's dark tone, shared with the reply composer so both surfaces read as one layer.
export const INBOUND_SURFACE_DARK_BG = "dark:bg-gray-800"

// White text on the dark blue bubble; the theme's gray tokens turn muddy on it.
const BLUE_DARK_TEXT =
	"dark:[--text-primary:theme(colors.white)] dark:[--text-secondary:rgb(255_255_255/0.85)] dark:[--text-tertiary:rgb(255_255_255/0.85)] dark:[&_.message-typography]:text-white"

export function messageSurfaceClasses({
	showBackground,
	isOutbound,
}: {
	showBackground: boolean
	isOutbound: boolean
}): string {
	if (!showBackground) return ""
	return isOutbound
		? `-mx-2 rounded-2xl px-3.5 pb-3 pt-3.5 bg-gray-100 ring-1 ring-black/5 ${INBOUND_SURFACE_DARK_BG} dark:ring-white/10`
		: `-mx-2 rounded-2xl px-3.5 pb-3 pt-3.5 bg-blue-100 dark:bg-blue-500/15 ${BLUE_DARK_TEXT}`
}

// The send time, Emailed label and read ticks on the blue (inbound) bubble read as the text colour at 50%, so they stay legible on blue in both themes.
export function messageTimestampClasses(isOutbound: boolean): string {
	return isOutbound ? "text-tertiary" : "text-primary opacity-50"
}

// Callers pass a footer whose parts often all render null; the empty box would still add its margin under the text.
export const MESSAGE_FOOTER_CLASS = "mt-2 empty:hidden"

// Comment bodies clear the avatar column: a 24px avatar plus the 12px gap next to it.
export const COMMENT_BODY_INDENT_CLASS = "pl-9"

// Same padding as the reply composer below it, so every row in a comment card has equal space above and below.
export const BARE_COMMENT_ROW_CLASS = "px-3.5 py-2.5"
